const BackgroundVideoSave = ({ backgroundVideoOptions }) => {
  const { video, mobileImage } = backgroundVideoOptions;
  return (
    <div className="e-bgv">
      {video?.source && (
        <video
          // eslint-disable-next-line react/no-unknown-property
          playsinline
          controls={video?.showControls}
          autoPlay={video?.autoPlay}
          muted={video?.mute}
          loop={video?.loop}
        >
          <source src={`${video?.source}#t=0.01`} type="video/mp4" />
        </video>
      )}
      {mobileImage && (
        <div className="e-bgv__mb-img">
          <img src={mobileImage?.url} alt={mobileImage?.alt} />
        </div>
      )}
    </div>
  );
};

export default BackgroundVideoSave;
